// src/views/RegisterPage.vue

<template>
  <div class="register-page-container">
    <RegistrationWizard />
  </div>
</template>

<script setup>
import RegistrationWizard from '@/components/RegistrationWizard.vue';
</script>

<style scoped>
  .register-page-container {
    padding: 2rem 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f4f7f6; /* Warna latar yang sama dengan layout utama */
  }
</style>